import React from "react";

const NeueTaskListStrongIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.5002 17.5H5C3.89543 17.5 3 16.6046 3 15.5V5C3 3.89543 3.89543 3 5 3H15.5002C16.6048 3 17.5002 3.89543 17.5002 5V15.5C17.5002 16.6046 16.6048 17.5 15.5002 17.5Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7 10.25L9.25 12.5L13.5 8",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(NeueTaskListStrongIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;